
/* Funzione per la visualizzazione delle imagini e del testo appartenenti al dettaglio itinerario(a piedi, in macchina, in bici).
 In questo componente vengono anche tradotte le stringhe per la direzione dei percorsi
*/

import React from 'react';
import FlagIcon from '@material-ui/icons/Flag';
import Left from './icon/LEFT.svg'
import Hard_left from './icon/HARD_LEFT.svg'
import Slightly_left from './icon/SLIGHTLY_LEFT.svg'
import Slightly_right from './icon/SLIGHTLY_RIGHT.svg'
import Right from './icon/RIGHT.svg'
import Hard_right from './icon/HARD_RIGHT.svg'
import Uturn_right from './icon/UTURN_RIGHT.svg'
import Uturn_left from './icon/UTURN_LEFT.svg'
import ClockWise from './icon/CLOCKWISE.svg'
import CounterClockWise from './icon/COUNTERCLOCKWISE.svg'
import Continue from './icon/CONTINUE.svg'
import { Trans } from 'react-i18next';

export const switchStepArrow = (item) =>{
      
    switch (item.relativeDirection) {
          
      case 'DEPART':
            return (<div className={"indicazioneContenitore"}> <FlagIcon/>
             <Trans>Partenza da</Trans> {item.streetName} <Trans>in direzione</Trans> <Trans>{item.absoluteDirection}</Trans>  </div>
             )
    
      case 'HARD_LEFT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Hard_left} style={{ height: 16, width: 16}} alt="calcolo" /> 
            <div className={"indicazioniTesto"}>
                  <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
            </div>)
      case 'LEFT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Left} fill="white" style={{ height: 16, width: 16}} alt="calcolo" /> 
            <div className={"indicazioniTesto"}> 
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
             </div>)
      case 'SLIGHTLY_LEFT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Slightly_left} style={{ height: 16, width: 16}} alt="calcolo" /> 
            <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
            </div>)
      case 'CONTINUE':
            return (
            <div className={"indicazioneContenitore"}>  <img src={Continue} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                    <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
            </div>)
      case 'SLIGHTLY_RIGHT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Slightly_right} style={{ height: 16, width: 16}} alt="calcolo" /> 
            <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
            </div>)
      case 'RIGHT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Right} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)
      case 'HARD_RIGHT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Hard_right} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)
      case 'CIRCLE_CLOCKWISE':
        
            return (<div className={"indicazioneContenitore"}>  <img src={ClockWise} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)  
      case 'CIRCLE_COUNTERCLOCKWISE':
        
            return (<div className={"indicazioneContenitore"}>  <img src={CounterClockWise} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                    <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)
      case 'ELEVATOR':
        
                        break;
      case 'UTURN_LEFT':
        
            return (<div className={"indicazioneContenitore"}>  <img src={Uturn_left} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                   <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)
      case 'UTURN_RIGHT':

            return (<div className={"indicazioneContenitore"}>  <img src={Uturn_right} style={{ height: 16, width: 16}} alt="calcolo" /> <div className={"indicazioniTesto"}>
                    <Trans>{item.relativeDirection}</Trans> <Trans>su</Trans> <Trans>{item.streetName}</Trans></div>
                   </div>)
      default:
        break;
    }
  }